import React, { Fragment } from 'react';
import cn from 'classnames';

export function RoomPlanRecomendations({ hideHint }) {
  return (
    <div id="modal-onboarding-customer-room-plan-recommendation" className="moodboard-modal">
      <div className="moodboard-modal_backdrop" onClick={hideHint} />
      <div className="moodboard-modal_dialog">
        <button className="moodboard-modal_close" type="button" onClick={hideHint} />
        <ul>
          <li>We just need some key dimensions to make sure items fit!</li>
          <li>A sketch is great, it doesn't need to be perfect</li>
          <li>Remember to include wall lengths & ceiling height</li>
          <li>Take a photo of your sketch and upload it</li>
        </ul>
      </div>
    </div>
  );
}

export function RoomPhotosRecomendations({ hideHint }) {
  return (
    <div id="modal-onboarding-customer-room-photos-recommendation" className="moodboard-modal">
      <div className="moodboard-modal_backdrop" onClick={hideHint} />
      <div className="moodboard-modal_dialog">
        <button className="moodboard-modal_close" onClick={hideHint} />
        <ul>
          <li>Turn all lights on in the room</li>
          <li>Take a photo of each of the four walls</li>
          <li>Include photos of windows & doors</li>
          <li>As well as any important features</li>
        </ul>
      </div>
    </div>
  );
}

export const ProjectSubmittedModal = ({ proPlatform, onClose, consultancy, nextProject }) => (
  <div id="modal-project-submitted" className="moodboard-modal -large">
    <div className="moodboard-modal_backdrop" onClick={onClose} />
    <div className="moodboard-modal_dialog">
      <button className="moodboard-modal_close" onClick={onClose} />

      <div className="moodboard-modal_info text-center">
        <div className={cn('moodboard-modal_title', '-big')}>
          Thank you.
          <br />
          Design Brief Complete!
        </div>
        <p>
          We’ll review your answers and match you with the best designer for your tastes and requirements.
        </p>
        <p>
          Keep an eye on your inbox,
          you'll be introduced to your designer on the CHAT to
          kick off the project.
        </p>
        {nextProject && (
          <Fragment>
            <p className='muted'>
              Visit your ACCOUNT to complete your other design briefs.
            </p>
            <p>
              <a href={nextProject.url} className='btn -lg -gold'>COMPLETE NEXT DESIGN BRIEF</a>
            </p>
            <p>
              <a href={nextProject.all_projects_url} className='moodboard-modal_link -muted '>I’ll complete later</a>
              <span className='moodboard-modal_link -muted -no-text-decoration'>&nbsp;></span>
            </p>
          </Fragment>
        )}
        {!nextProject && (
          <Fragment>
            <p>
              In the mean time why not visit our blog for inspiration and top tips.
            </p>
            <a href={'/projects'} className='btn -lg -gold'>EXIT</a>
          </Fragment>
        )}
      </div>
    </div>
  </div>
);

export function showRoomPhotoHint() {
  $('#modal-onboarding-customer-room-photos-recommendation').addClass('-open');
  $('body').addClass('modal-open');
}

export function hideRoomPhotoHint() {
  $('#modal-onboarding-customer-room-photos-recommendation').removeClass('-open');
  $('body').removeClass('modal-open');
}

export function showRoomPlanHint() {
  $('#modal-onboarding-customer-room-plan-recommendation').addClass('-open');
  $('body').addClass('modal-open');
}

export function hideRoomPlanHint() {
  $('#modal-onboarding-customer-room-plan-recommendation').removeClass('-open');
  $('body').removeClass('modal-open');
}

export function showProjectSubmittedModal() {
  $('#modal-project-submitted').addClass('-open');
  $('body').addClass('modal-open');
}

export function hideProjectSubmittedModal() {
  $('#modal-project-submitted').removeClass('-open');
  $('body').removeClass('modal-open');
}



// WEBPACK FOOTER //
// ./app/javascript/components/customer/brief/untils/pop-up-helpers.js